import { render, staticRenderFns } from "./menu_list.vue?vue&type=template&id=22d3c674&scoped=true&"
import script from "./menu_list.vue?vue&type=script&lang=js&"
export * from "./menu_list.vue?vue&type=script&lang=js&"
import style0 from "./menu_list.vue?vue&type=style&index=0&id=22d3c674&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d3c674",
  null
  
)

export default component.exports